import { useContext, useEffect } from 'react';
import { createId } from '@paralleldrive/cuid2';
import { ChatSessionPendingQueryContext, ActiveChatSessionContext } from '@trinity/chat-components/components/Chat/context';
import { useSubmitQueryMutation } from '@trinity/chat-components/components/Chat/hooks/useSubmitQueryMutation';
import { ChatStateDispatchContext } from './context';

type Props = {
  children: React.ReactNode;
};

export const ChatPendingQueryContextContainer = ({ children }: Props) => {
  const pendingQuery = useContext(ChatSessionPendingQueryContext);
  const chat = useContext(ActiveChatSessionContext);
  const submitQueryMutation = useSubmitQueryMutation();
  const dispatch = useContext(ChatStateDispatchContext);

  useEffect(() => {
    if (!pendingQuery || !chat?.identifier || !chat?.context || submitQueryMutation.isPending) {
      return;
    }

    const queryIdentifier = createId();

    submitQueryMutation.mutate({
      identifier: queryIdentifier,
      parentQueryIdentifier: null,
      query: pendingQuery,
      action: null,
    }, {
      onSettled: () => {
        dispatch({
          type: 'pending-query-reset',
          payload: {},
        });
      },
    });
  }, [pendingQuery, chat?.identifier, chat?.context, submitQueryMutation, dispatch]);

  return <>{children}</>;
};
